// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"297":"eb25ebeb","667":"b37511de"}[chunkId] + ".chunk.js");